import { CombinedLoadingOptsViewModel } from '../../../../shared/components/auto-save/combined-loading-opts-view-model';
import { Injectable } from '@angular/core';
import { EditTemplateSpotlightMenuViewModel } from './edit-template-spotlight-menu-view-model';
import { EditSpotlightMenuViewModel } from '../../../../menu/components/edit-menu/edit-spotlight-menu/edit-spotlight-menu-view-model';
import { EditSpotlightSectionViewModel } from '../../../../menu/components/edit-menu/edit-spotlight-menu/edit-spotlight-section-view-model';

@Injectable()
export class EditTemplateSpotlightMenuCombinedLoadingOptsViewModel extends CombinedLoadingOptsViewModel {
  constructor(
    private editTemplateSpotlightMenuViewModel: EditTemplateSpotlightMenuViewModel,
    private editSpotlightMenuViewModel: EditSpotlightMenuViewModel,
    private editSpotlightSectionViewModel: EditSpotlightSectionViewModel
  ) {
    super([editTemplateSpotlightMenuViewModel, editSpotlightMenuViewModel, editSpotlightSectionViewModel]);
  }
}
